import { classNames } from "@greeter/util";
import css from "./Thumb.module.scss";

export type ThumbProps = React.ComponentProps<"img"> & {
  size?: "sm" | "md";
};

export function Thumb({ className, size, ...props }: ThumbProps) {
  return (
    <img
      {...classNames(className, "thumb", size === "sm" && css.Small, css.Thumb)}
      {...props}
    />
  );
}
